import Icon from 'veui/components/Icon'
import { IconTrash } from 'dls-icons-vue'

Icon.register('trash', IconTrash)
